import $ from 'jquery';
import layout from '../Layout';

export default class StickyHeader {
  constructor(options, settings) {
    this.postMessage = options.postMessage;
    this.$body = $(document.body);
    this.$window = $(window);
    this.$siteMain = $('.site-main');

    this.$el = options.$el;
    this.$toggle = options.$toggle;
    this.settings = settings;

    this.stickyClass = 'site-header-sticky';
    this.scrolledClass = 'site-header-sticky--scrolled';
    this.navOpenClass = 'site-header-sticky--open';

    this.headerMainEl = this.$el[0].querySelector('[data-site-header-main]');
    this.headerNavEl = this.$el[0].querySelector('.site-navigation-wrapper');

    if (!this.settings.sticky_header) {
      return this._stickyReset();
    }

    // Revert navigation to original state on breakpoint change
    this.navVisibility = this.navVisibility.bind(this);
    layout.onBreakpointChange(this.navVisibility);

    this._stickyOffset = this._stickyOffset.bind(this);
    layout.onBreakpointChange(this._stickyOffset);

    this._toggleStickyHeader = this._toggleStickyHeader.bind(this);

    this._init();
  }

  closeNavigation() {
    if (!this.settings.sticky_header) return;

    this.$el.removeClass(this.navOpenClass).one('trend', () => {
      this.$body.trigger('position-banners');
    });
    this.postMessage('nav:close-all');
  }

  openNavigation() {
    this.$el.addClass(this.navOpenClass).one('trend', () => {
      this.$body.trigger('position-banners');
    });
  }

  navVisibility(event, breakpoints) {
    if (breakpoints.previous === 'L') this.closeNavigation();
  }

  unload() {
    if (!this.settings.sticky_header) return;

    this.$body.removeClass(this.stickyClass).removeClass(this.scrolledClass);

    this.$toggle.off('.sticky-header');
    this.$window.off('.sticky-header');

    layout.offBreakpointChange(this.navVisibility);
    layout.offBreakpointChange(this._stickyOffset);
  }

  _init() {
    this._stickyOffset();
    this._bindEvents();
    this._toggleStickyHeader();
  }

  _bindEvents() {
    this.$toggle.on('click.sticky-header', (event) => {
      event.preventDefault();

      if (layout.isBreakpoint('L')) this._slideToggle();
    });

    this.$window.on('scroll.sticky-header', this._toggleStickyHeader);
  }
  
  _stickyReset() {
    this.$el.data('header-offset', '');
    this.$siteMain.css('paddingTop', '');
  }
  
  /**
   * Determine the offset when breakpoints change
   *  - Offset is used to determine scroll threshold
   *  - Offset is used to set a body offset on browsers that don't support Sticky
   */
  _stickyOffset() {
    let offset = this.headerMainEl.getBoundingClientRect().height;

    if (layout.isBreakpoint('L')) {
      offset = offset + this.headerNavEl.getBoundingClientRect().height;
    }

    if (!this.$body.hasClass(this.stickyClass)) {
      this.$body.addClass(this.stickyClass);
    }

    this.$el.data('header-offset', offset);
    this.$siteMain.css('paddingTop', offset);
  }

  _slideToggle() {
    if (this.$el.hasClass(this.navOpenClass)) {
      this.closeNavigation();
      this.$toggle.removeClass('active');
    } else {
      this.openNavigation();
      this.$toggle.addClass('active');
    }
  }

  /**
   * Sticky header only shows as sticky after scroll
   *
   * @private
   */
  _toggleStickyHeader() {
    const offset = parseInt(this.$el.data('header-offset'), 10) || 200;
    const scrollThreshold = window.pageYOffset > (offset + 20);

    // Sticky header is scrolled, is and is visible -- nothing more to do!
    if (scrollThreshold && this.$body.hasClass(this.scrolledClass)) {
      return;
    }

    // Is within threshold
    if (scrollThreshold) {
      this._shrink();
    } else {
      this._expand();
    }
  }

  _shrink(){
    this.closeNavigation();
    this.$toggle.removeClass('active');

    this.$el
      .revealer('show')
      .one('revealer-animating.sticky-header', () => {
        this.$body.addClass(this.scrolledClass).one('trend', () => {
          this.$body.trigger('position-banners');
        });
      });
  }

  _expand(){
    this.openNavigation();

    this.$el
      .revealer('hide')
      .one('revealer-animating.sticky-header', () => {
        this.$body.removeClass(this.scrolledClass).one('trend', () => {
          this.$body.trigger('position-banners');
        });
      }).one('revealer-hide.sticky-header', () => {
        this.$toggle.removeClass('active');
      });
  }
}
